export default __webpack_public_path__ + "static/Imme_2.2-3706a52129cf6faa139aea8719e23374.png";